import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import SessionModel from "../../models/masters/session-model";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Session/GetAllSession";// //{/api/Session/GetAllSession}`)  //// "https://localhost:7054/api/Session/GetAllSession";
export const useGetSessions = createQuery<
  SessionModel[],
  null,
  AxiosError
>({
  queryKey: ["keySessionlist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});